import { render, staticRenderFns } from "./TeachingPlanDataTable.vue?vue&type=template&id=3b1b5156&scoped=true&"
import script from "./TeachingPlanDataTable.vue?vue&type=script&lang=js&"
export * from "./TeachingPlanDataTable.vue?vue&type=script&lang=js&"
import style0 from "./TeachingPlanDataTable.vue?vue&type=style&index=0&id=3b1b5156&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1b5156",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VChip,VDataTable,VIcon})
